import { UseQueryResult } from '@tanstack/react-query';
import { BikeleasingV2ContractsListDTO } from 'probonio-shared-ui/api';
import { apis, useTenantQuery } from 'probonio-shared-ui/module/api';

export function useContractList(options?: { enabled?: boolean; staleTime?: number }): UseQueryResult<BikeleasingV2ContractsListDTO, Error> {
  return useTenantQuery(
    ['contracts', apis.bikeLeasingV2.listContracts.name],
    tenantId => apis.bikeLeasingV2.listContracts({ tenantId }).then(res => res.data),
    {
      staleTime: 5 * 60 * 1000, // refetch contracts every 5 minutes
      ...options,
    },
  );
}
